import * as actions from './actions'

// initial state
const state = {
  carwashCoupon: [
    {
      name: '',
      shortDescription: '',
      description: '',
      usableStartAt: '',
      usableEndAt: '',
      category: '',
      iconPath: '',
      uuid: '',
      saleValue: '',
      usableCount: null,
      chargeValue: '',
      bearer: '',
      hash: '',
      // 当該クーポンが選択されている場合は true
      isSelectedCoupon: false
    }
  ]
}

// getters
const getters = {
  carwashCoupon: (state) => {
    return state.carwashCoupon
  }
}

// mutations
const mutations = {
  SET_CARWASH_COUPON (state, data) {
    data.forEach(element => {
      element.isSelectedCoupon = false
    })
    state.carwashCoupon = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
